import { Star } from "lucide-react";

import { cn } from "@/lib/cn";
import { IconButton } from "@/components/ui/IconButton";
import { useFavourites, type FavouriteKind } from "@/lib/favourites";

export interface FavouriteButtonProps {
  /** The address to pin: pathname plus search. */
  to: string;
  /** What the sidebar calls it. */
  label: string;
  kind?: FavouriteKind;
  size?: "sm" | "md";
  className?: string;
}

/**
 * The star that pins a place to the top of the sidebar.
 *
 * Hollow until it is pinned, then filled in the accent. The colour is on the
 * icon rather than the button, so the button keeps the hover every other
 * icon button has.
 */
export function FavouriteButton({
  to,
  label,
  kind = "screen",
  size = "sm",
  className,
}: FavouriteButtonProps) {
  const { isFavourite, toggle } = useFavourites();
  const pinned = isFavourite(to);
  return (
    <IconButton
      label={pinned ? "Unpin" : "Pin to the sidebar"}
      size={size}
      data-print="hide"
      onClick={() => toggle({ to, label, kind })}
      icon={
        <Star className={cn("size-4", pinned ? "fill-current text-accent" : "text-fg-subtle")} />
      }
      className={className}
    />
  );
}
